import { render, staticRenderFns } from "./SaleTypeEditGeneralPrintAfterSend.vue?vue&type=template&id=f56f8424"
import script from "./SaleTypeEditGeneralPrintAfterSend.vue?vue&type=script&lang=ts"
export * from "./SaleTypeEditGeneralPrintAfterSend.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports